module.exports = __webpack_public_path__ + "img/shape.cca8a569.png";